/**
 * Validasi Saldo Akhir — Types
 *
 * Saldo Akhir List (angka yang akan ditransfer Tutup Buku Tahunan) vs Saldo COA,
 * per COA Buku Pengawasan. Hanya tahun NORMAL. Angka COA asing dalam MUA.
 *
 * @see .claude/docs/Booku v2/buku-pengawasan/validasi-saldo-akhir.md
 */

/**
 * Path halaman — WAJIB sama dengan `path` di PageRegistry & menuConfig. Dipakai tautan dari
 * Tutup Buku Tahunan & Neraca Lajur (impor dari berkas ini, BUKAN `index.ts`, supaya halaman
 * tetap lazy-load).
 */
export const ValidasiSaldoAkhir_Path = '/buku-pengawasan/validasi-saldo-akhir';

/** Satu baris jurnal manual (menu Jurnal Umum) yang menyentuh COA — isi drawer "Telusuri". */
export interface JurnalManualCoa {
  nomorJV: number;
  tanggalTransaksi: string;
  /** True = bulannya sudah ditutup; membetulkannya butuh Reset Laporan Bulanan dulu. */
  bulanTertutup: boolean;
  jenisJurnal: string;
  kodeMataUang: string;
  debet: number;
  kredit: number;
  uraian: string;
  namaLawanTransaksi: string;
  usernameEntry: string;
}

/** Satu baris COA. Angka dalam mata uang `kodeMataUang`. */
export interface ValidasiSaldoAkhirItem {
  kodeCOA: string;
  namaCOA: string;
  kodeMataUang: string;
  /** null = belum terkunci ke angka transfer. */
  saldoAkhirList: number | null;
  /** Saldo_Desember bila seluruh bulan tertutup, selain itu posisi terkini. */
  saldoAkhirCOA: number;
  /** List − COA. null = belum terkunci. */
  selisih: number | null;
  isTerkunci: boolean;
  tooltipReason: string | null;
  /** Diisi bila memakai Saldo_Desember dan posisi terkini berbeda (ada jurnal di bulan tertutup). */
  saldoCOATerkiniBerbeda: number | null;
  modulRoute: string;
}

export interface ValidasiSaldoAkhirKategori {
  kode: string;
  nama: string;
  urutan: number;
  items: ValidasiSaldoAkhirItem[];
}

/** Response GET /api/validasi-saldo-akhir. */
export interface ValidasiSaldoAkhirResponse {
  kategori: ValidasiSaldoAkhirKategori[];
  totalCoaBalance: number;
  totalCoaSelisih: number;
  totalCoaBelumTerkunci: number;
  tahunBuku: number;
  bulanBukuAktif: number;
  memakaiSaldoDesember: boolean;
}
